import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'lib-andromeda-menu-option',
  templateUrl: './andromeda-menu-option.component.html',
  styleUrls: ['./andromeda-menu-option.component.scss'],
})
export class AndromedaMenuOptionComponent {
  @Output() optionHasBeenClicked = new EventEmitter<boolean>();

  constructor() {
    // This is intentional
  }

  onClickOnOption(event): void {
    this.optionHasBeenClicked.next(event);
  }
}
